module.exports = __webpack_public_path__ + "static/media/arrows-v.f9c03ead.svg";